<div class="company-container mt-2">
  <div class="top-part pt">
    <div class="top-part-wrap">
      <div class="table-main-header">Carriers</div>
      <div class="d-flex">
        <div class="searchbox d-flex me-2" id="searchbox">
          <img src="assets/images/products-listing/searchbar.png" />
          <input
            type="text"
            class="ms-2"
            placeholder="Search..."
            id="search-input"
            [ngModel]="search"
            (ngModelChange)="handleSearch($event)"
          />
        </div>
        <ng-template [ngxPermissionsOnly]="['Carrier:Create']">
          <button
            class="btn primary-btn"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasAddCarrier"
            (click)="openAddEditForm(0)"
            aria-controls="offcanvasRight"
          >
            <img src="assets/images/icons/Plus_Icon.svg" class="me-1" />Add Carrier
          </button>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="table-container user-table">
    <div *ngIf="loading" class="loading-overlay">
      <div class="spinner-border text-primary custom-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <table class="table locationtype-table align-middle">
      <thead class="br-10">
        <tr>
          <th class="col ps-3" style="width: 25%">Name</th>
          <th class="col text-start" style="width: 35%">Description</th>
          <th class="col pe-5" style="width: 30%">Email</th>
          <th class="col text-center" >Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let carrier of carriers">
          <td class="col ps-3">
            {{ carrier.name }}
          </td>
          <td class="col ps-3 align-middle" style="max-width: 200px; word-wrap: break-word">
            {{ carrier.description ? (carrier.description | slice: 0 : 70) : '' }}
            <span *ngIf="carrier.description && carrier.description.length > 70">
              ...
              <span class="text-primary" [appCustomTooltip]="carrier.description"> View </span>
            </span>
          </td>
          <td class="col pe-5">{{ carrier.email }}</td>
          <td class="col">
            <div class="d-flex justify-content-center">
              <ng-template [ngxPermissionsOnly]="['Carrier:Update']">
                <button
                  class="btn p-0 c-pt me-3"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasAddCarrier"
                  aria-controls="offcanvasRight"
                  (click)="openAddEditForm(carrier.id)"
                  style="border: none"
                  matTooltipPosition="above"
                  matTooltip="Edit Record"
                >
                  <img src="assets/images/icons/edit_ic.svg" />
                </button>
              </ng-template>
              <ng-template [ngxPermissionsOnly]="['Carrier:Delete']">
                <div (click)="handleDeleteClick(carrier)">
                  <button
                    class="btn border-0 p-0 c-pt"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteCarrierModal"
                    aria-expanded="false"
                    (click)="selectRecordToDelete(carrier)"
                    style="border: none"
                    matTooltipPosition="above"
                    matTooltip="Delete Record"
                  >
                    <img src="assets/images/icons/Delete_icon.svg" />
                  </button>
                </div>
              </ng-template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      *ngIf="carriers.length === 0"
      class="nodata"
      style="height: 56vh; display: flex; align-items: center"
    >
      <p style="margin: auto; font-size: 2rem; color: #a4a4a4">No Data Available</p>
    </div>
  </div>
</div>

<!-- Offcanvas for Add/Edit -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasAddCarrier"
  aria-labelledby="offcanvasRightLabel"
  data-bs-backdrop="static"
>
  <ng-container>
    <app-add-edit-carrier
      #addEditComponent
      (triggerParentMethod)="handleTriggerFromChild()"
    ></app-add-edit-carrier>
  </ng-container>
</div>

<!-- Delete Confirmation Modal -->
<div
  class="modal fade"
  id="deleteCarrierModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Confirm Deletion</h5>
      </div>
      <div class="modal-body">
        <p>
          Are you sure you want to delete the carrier "<b>{{ carrierObj.name }}</b
          >" from your records?
        </p>
        <p class="mt-3" style="font-weight: 600">
          This action will permanently remove the carrier from the records.
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn pri-btn me-2" data-bs-dismiss="modal">Cancel</button>
        <button class="btn cancel-btn ms-2 w-auto" data-bs-dismiss="modal" (click)="deleteRecord()">
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>
